import { styleToObject } from '@dealerportal/utilities';
import classNames from 'classnames';
import Image from 'next/image';
import type { EnhancedDOMNode } from './Include';

export const validateTags = (node: EnhancedDOMNode) => {
  return node.tagName === 'galleryitembase' || node.tagName === 'slide';
};

type Props = {
  autoplayspeed?: string;
  containerclass?: string;
  transitionduration?: string;
  isFeatureImage?: boolean;
  visible?: boolean;
  elementToRender: EnhancedDOMNode;
};

export const FaderCarouselItem: React.FC<Props> = ({
  visible,
  isFeatureImage,
  transitionduration,
  elementToRender,
}: Props) => {
  const { attribs } = elementToRender;

  if (!attribs.src) return null;

  return (
    <div
      style={{
        opacity: visible ? '1' : '0',
        transitionDuration: transitionduration || '3000ms',
        ...styleToObject(attribs.style),
      }}
      className={classNames(
        'ui-inset-0 ui-overflow-hidden ui-transition-opacity',
        attribs.class,
        {
          'ui-absolute': !isFeatureImage,
        }
      )}
    >
      <Image
        src={attribs.src}
        alt={attribs.alt ?? attribs.title}
        title={attribs.title}
        fill={true}
        className={classNames(
          'ui-min-h-full !ui-w-auto !ui-h-auto',
          attribs.class,
          {
            '!ui-m-0': isFeatureImage,
          }
        )}
        draggable={false}
      />
    </div>
  );
};

export default FaderCarouselItem;
